<template>
	<div class="square-container flex items-center">
		<img class="image" ref="imageRef" :src="`${publicPath}assets/img/logo-bagi.png`" alt="">
	</div>
</template>

<script>
export default {
	name: 'LogoAbi',

	props: {
		size_prop: {
			type: String,
			default: '30em', // px or em
		},
	},

	data() {
		return {
			publicPath: process.env.BASE_URL,
		}
	},

	mounted() {
		this.$nextTick(() => {
			if (this.$refs.imageRef) {
				this.$refs.imageRef.style.width = `${this.size_prop}`
				this.$refs.imageRef.style.height = 'auto' // Maintain the aspect ratio
			}
		})
	},
}
</script>

<style scoped>
.square-container {
	/* Ensure the container wraps tightly around the image */
	position: relative;
	width: auto;
	/* Dynamically adjusts to the image width */
	aspect-ratio: 1;
	/* Makes the container square */
}

.image {
	display: block;
	/* Removes extra space below the image */
	object-fit: contain;
	/* Prevents distortion of the image */
}
</style>